<template>
    <div>
      <div class="pull-right header-right" v-if="userInfo.user">
        <div class="header-main">
          <div class="header-info pull-right">
            <span class="pull-left avatar"><img :src="userInfo.user.head" alt="" class="img-circle profile-avatar" width="24" height="24"></span>
            <el-badge is-dot v-if="msgTotal >0">
              <span class="user-email">{{userInfo.user.userName}}</span>
            </el-badge>
            <span class="user-email" v-else>{{userInfo.user.userName}}</span>
            <span class="arr-down"><i class="arrow"></i></span>
            <ul class="drop-menu clearfix">
              <li class="drop-menu-item header-item-profile col-sm-12">
                <router-link to="/userInfo">
                  <a class="header-item-link">
                    <i class="icon-profile ldms-font ldms-renyuan"></i>
                    <span class="header-item-title"> 个人中心</span>
                  </a>
                </router-link>
              </li>
              <li class="drop-menu-item header-item-profile col-sm-12">
                <router-link to="/dashboard">
                  <a class="header-item-link">
                    <i class="icon-profile ldms-font ldms-yingyong"></i>
                    <span class="header-item-title"> 个人应用</span>
                  </a>
                </router-link>
              </li>
              <li class="drop-menu-item header-item-profile col-sm-12">
                <router-link to="/userMessage">
                  <a class="header-item-link">
                    <i class="icon-profile ldms-font el-icon-bell"></i>
                    <span class="header-item-title"> 消息</span><span class="tips" v-if="msgTotal >0">{{msgTotal}}</span>
                  </a>
                </router-link>
              </li>
              <li class="drop-menu-item logout col-sm-12 text-center">
                <a @click="logout" class="header-item-link">退出登录</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ul class="header-user pull-right" v-if="!userInfo.user">
        <li class="pull-left">
          <router-link to="/login">
            <a class="login">登录</a>
          </router-link>
        </li>
        <li class="pull-right">
          <router-link to="/register">
            <a class="btn btn-org-empty register">免费注册</a>
          </router-link>
        </li>
      </ul>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getTotalMsg } from '../../api/message'

export default {
  data () {
    return {
      user: '',
      msgTotal: 0
    }
  },
  computed: {
    ...mapGetters({userInfo: 'user/userInfo'})
  },
  created () {
    let _this = this
    if (this.userInfo.user) {
      getTotalMsg().then(response => {
        _this.msgTotal = response.data.data
      })
    }
  },
  watch: {
  },
  methods: {
    logout () {
      this.logOut({'router': this.$router})
    },
    ...mapActions({logOut: 'user/logOut'})
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.tips
  background-color: #f56c6c
  border-radius: 10px
  color: #fff
  display: inline-block
  font-size: 12px
  height: 18px
  line-height: 18px
  padding: 0 6px
  text-align: center
  white-space: nowrap
  border: 1px solid #fff
</style>
